export var WorkspacePluginStatus;
(function (WorkspacePluginStatus) {
    WorkspacePluginStatus["NOT_CONNECTED"] = "NOT_CONNECTED";
    WorkspacePluginStatus["CONNECTED"] = "CONNECTED";
    WorkspacePluginStatus["ERROR"] = "ERROR";
})(WorkspacePluginStatus || (WorkspacePluginStatus = {}));
//# sourceMappingURL=workspace-plugin-status.enum.js.map